import { useSelector } from 'react-redux';

export const useSelectAddress = () => useSelector(({ order }) => order?.address ?? {});
